import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

/**
 * Тригерить `refetch` при ЗРОСТАННІ лічильника `state.updatesHub.badges.notifications`.
 *
 * Сценарій: експерт підтвердив зустріч → бек emit'ить notification клієнту → WS шле
 * `updates-hub:badges` з новим (більшим) лічильником → клієнт на сторінці /appointments
 * має побачити оновлений статус без F5.
 *
 * Чому "тільки зростання": при mark-as-read лічильник зменшується — refetch там не
 * потрібен (notification про appointment ми вже відпрацювали при кліку, нової зміни немає).
 *
 * Це грубий проксі через "будь-яка нова notification → refetch appointments". Зайвий
 * refetch при пуш-нотифікації чату/новин теж відбудеться — це 1 кешований REST-запит,
 * прийнятно. Якщо коли-небудь стане проблемою, перейти на окремий WS event
 * `appointments.updated` з боку беку.
 */
export function useRefetchOnNotification(refetch: () => void) {
  const count = useSelector((state: RootState) => state.updatesHub.badges.notifications);
  const prevRef = useRef(count);

  useEffect(() => {
    if (count > prevRef.current) {
      refetch();
    }
    prevRef.current = count;
  }, [count, refetch]);
}
